var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScenarioIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.4 27.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Scenarij") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ikone"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ikone-2",
    "data-name": "ikone"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.2,
    cy: 15.41,
    r: 11.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.2,
    y1: 15.63,
    x2: 12.2,
    y2: 7.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.03,
    y1: 15.29,
    x2: 18.58,
    y2: 20.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.32,
    y1: 0.81,
    x2: 0.68,
    y2: 4.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 18.08,
    y1: 0.81,
    x2: 23.73,
    y2: 4.91
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenarioIcon);
export default __webpack_public_path__ + "static/media/scenarioIcon.3acd3941768f356e3045584859d10e55.svg";
export { ForwardRef as ReactComponent };